import CarnivoreContext from 'contexts/CarnivoreContext';
import CarnivoreLib, {
  getCarnivoreLibComponent,
} from 'editor/components/CarnivoreLib';
import React, { FC, PropsWithChildren, useEffect, useState } from 'react';

type Props = PropsWithChildren<unknown>;

const CarnivoreProvider: FC<Props> = (props: Props) => {
  const { children } = props;

  const [carn, setCarn] = useState<CarnivoreLib | null>(null);

  useEffect(() => {
    async function getCarnivoreLib() {
      const _carn = await getCarnivoreLibComponent();

      setCarn(_carn);
    }

    getCarnivoreLib();
  }, []);

  return carn ? (
    <CarnivoreContext.Provider value={carn}>
      {children}
    </CarnivoreContext.Provider>
  ) : null;
};

export default CarnivoreProvider;
